export default __webpack_public_path__ + "static/media/girlGym.55a01154.jpg";